import { ajaxCall } from "./ajax";

/**
 * Add a inZone value to the dataset of the postcode if in zone
 */
export default class shippingZoneChecker {
  constructor() {
    this.init();

    if (!this.postcode) {
      return;
    }

    this.addEventListeners();
    this.getBillingZone();

    if (!this.shippingPostcode) {
      return;
    }

    this.addShippingEventListeners();
    this.getShippingZone();
  }

  async getBillingZone() {
    if (this.postcode.value == "") {
      return null;
    }

    if (!this.isValidPostcode(this.postcode)) {
      this.postcode.removeAttribute("data-in-zone");
      this.postcodeInvalidDialog.style.display = "";
      this.previousPostcode = null;
      this.previousPostcodeInZone = null;
      return null;
    }

    this.postcodeInvalidDialog.style.display = "none";

    if (this.postcode.value == this.previousPostcode) {
      this.showBillingZoneMessage(this.previousPostcodeInZone);
      return this.previousPostcodeInZone;
    }

    this.previousPostcode = null;
    this.previousPostcodeInZone = null;

    let res = await ajaxCall("checkShippingZone", { postcode: this.postcode.value });

    this.previousPostcode = this.postcode.value;

    if (res.data && res.data.success) {
      this.postcode.dataset.inZone = res.data.data.in_zone;
      this.previousPostcodeInZone = res.data.data.in_zone;

      this.showBillingZoneMessage(res.data.data.in_zone);

      return res.data.data.in_zone;
    }

    return null;
  }

  async getShippingZone() {
    if (!this.isValidPostcode(this.shippingPostcode)) {
      this.shippingPostcode.removeAttribute("data-in-zone");
      this.previousShippingPostcode = null;
      this.previousShippingPostcodeInZone = null;
      return null;
    }

    if (this.shippingPostcode.value == this.previousShippingPostcode) {
      this.showShippingZoneMessage(this.previousShippingInZone);
      return this.previousShippingInZone;
    }

    this.previousShippingPostcode = null;
    this.previousShippingPostcodeInZone = null;

    let res = await ajaxCall("checkShippingZone", { postcode: this.shippingPostcode.value });

    this.previousShippingPostcode = this.shippingPostcode.value;

    if (res.data && res.data.success) {
      this.shippingPostcode.dataset.inZone = res.data.data.in_zone;
      this.previousShippingInZone = res.data.data.in_zone;
      this.showShippingZoneMessage(this.previousShippingInZone);
      return res.data.data.in_zone;
    }

    return null;
  }

  showShippingZoneMessage(inZone) {
    if (inZone) {
      this.shippingPostcodeDialog.style.display = "none";
      return;
    }
    this.shippingPostcodeDialog.style.display = "";
  }

  showBillingZoneMessage(inZone) {
    if (inZone) {
      this.postcodeDialog.style.display = "none";
      return;
    }
    this.postcodeDialog.style.display = "";
  }

  isValidPostcode(postcodeElement) {
    if (postcodeElement.value == "") {
      return false;
    }

    postcodeElement.value = postcodeElement.value.replace(" ", "").toUpperCase();

    // Check postcode without showing error in case user is not done typing
    if (!/^\d{4}[[a-zA-Z]{2}$/.test(postcodeElement.value)) {
      return false;
    }

    return true;
  }

  addEventListeners() {
    this.postcode.addEventListener("input", () => {
      this.getBillingZone();
    });
    this.postcode.addEventListener("blur", () => {
      this.getBillingZone();
    });
  }

  addShippingEventListeners() {
    this.shippingPostcode.addEventListener("input", () => {
      this.getShippingZone();
    });
    this.shippingPostcode.addEventListener("blur", () => {
      this.getShippingZone();
    });
  }

  init() {
    this.postcode = document.getElementById("billing_postcode");
    this.postcodeDialog = document.querySelector("#billing_postcode_field span.not-in-zone");
    this.postcodeInvalidDialog = document.querySelector("#billing_postcode_field span.postcode");
    this.previousPostcode = null;
    this.previousPostcodeInZone = null;

    this.shippingPostcode = document.getElementById("shipping_postcode");
    this.shippingPostcodeDialog = document.querySelector("#shipping_postcode_field span.not-in-zone");
    this.previousShippingPostcode = null;
    this.previousShippingPostcodeInZone = null;
  }

  debounce(func, wait, immediate) {
    var timeout;
    return function() {
      var context = this,
        args = arguments;
      clearTimeout(timeout);
      timeout = setTimeout(function() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      }, wait);
      if (immediate && !timeout) func.apply(context, args);
    };
  }
}
